export interface IndustryDefaultBrandRow {
  industry: string;
  defaultBrand?: string | null;
}

/**
 * The My Brand an Explore page opens with for one industry.
 *
 * Order: the admin-set per-industry default, then the tenant-wide
 * `tenant_settings.defaultBrand` for tenants not yet configured per industry.
 * A candidate only wins when it belongs to the industry's brand roster, so a
 * brand from another industry can never be the default.
 */
export function resolveIndustryDefaultBrand(args: {
  industry: string | null | undefined;
  industryDefaults: readonly IndustryDefaultBrandRow[];
  tenantDefaultBrand: string | null | undefined;
  validBrandNames: readonly string[];
}): string | null {
  const { industry, industryDefaults, tenantDefaultBrand, validBrandNames } = args;
  if (!industry || validBrandNames.length === 0) return null;

  const perIndustry = industryDefaults.find((row) => row.industry === industry)?.defaultBrand;
  const candidates = [perIndustry, tenantDefaultBrand];
  return candidates.find((name): name is string => !!name && validBrandNames.includes(name)) ?? null;
}
